module.exports = __webpack_public_path__ + "img/zs-l.964c16a3.png";